import React from 'react'
import { Heading, Paragraph } from '@pandiafi/design-system'
import { useTranslation } from 'react-i18next'

import { Contract, ContractTenant } from '../../../../../common/validations'
import { TenantChoice } from '../../../ContractChanges/components/TenantChoice/TenantChoice'
import { lockChoiceByTenantStatus } from '../../../ContractChanges/components/TenantChoice/lockChoiceByTenantStatus'
import { resolveContractTerminationTerminology } from '../../../ContractChanges/utils/resolveContractTerminationTerminology'

type AllTenantsMoveOutSummaryProps = {
  contract: Contract
  tenants: ContractTenant[]
}

export const AllTenantsMoveOutSummary: React.FC<
  AllTenantsMoveOutSummaryProps
> = ({ contract, tenants }) => {
  const { t } = useTranslation(['terminateContract', 'contractModification'])
  const terminology = resolveContractTerminationTerminology(
    contract.contractType
  )

  return (
    <>
      <Heading element="h3" size="l" className="mb-4 font-medium">
        {t('terminateContract:headings.parties')}
      </Heading>

      <Paragraph large className="mb-6">
        {t(terminology.allTenantsMoveOutDescription)}
      </Paragraph>

      {tenants.map((tenant) => (
        <TenantChoice
          key={tenant.id}
          tenant={tenant}
          isCurrentUser={tenant.id === contract.tenant.id}
          choice={lockChoiceByTenantStatus(contract, tenants, tenant, {
            type: 'locked',
            label: t('contractModification:tenantChoices.movesOut'),
          })}
        />
      ))}
    </>
  )
}
